var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"breadcrumb-menu"},_vm._l((_vm.menus),function(menu){return _c('li',{key:menu.path,staticClass:"breadcrumb-menu-item",class:{ 'is-current': _vm.currentPath === menu.path }},[_c('a',{attrs:{"href":menu.path}},[_vm._v(_vm._s(menu.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }